import ImageAndTextBlock from './ImageAndTextBlock'

export default ImageAndTextBlock
